var exports = {
  "container": "xae11d333--225bf4--container",
  "container-desktop": "xae11d333--225bf4--container-desktop",
  "container-phone": "xae11d333--225bf4--container-phone",
  "container-tablet": "xae11d333--225bf4--container-tablet",
  "title": "xae11d333--225bf4--title",
  "logo-block": "xae11d333--225bf4--logo-block",
  "logo": "xae11d333--225bf4--logo",
  "logo-desktop": "xae11d333--225bf4--logo-desktop",
  "logo-phone": "xae11d333--225bf4--logo-phone",
  "logo-tablet": "xae11d333--225bf4--logo-tablet",
};

module.exports = exports;
